export default "__VITE_ASSET__$W9Cl0Ac__"